module.exports = __webpack_public_path__ + "assets/img/ab9b235d782b15ceaf556f28b0eb40c7.svg";